import createReactComponent from '../createReactComponent';
var HardHat = createReactComponent('HardHat', [['path', {
  d: 'M2 18a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H3a1 1 0 00-1 1v2z',
  key: '9dub5t'
}], ['path', {
  d: 'M10 10V5a1 1 0 011-1h2a1 1 0 011 1v5',
  key: '1qxnmn'
}], ['path', {
  d: 'M4 15v-3a6 6 0 016-6h0',
  key: '1lkd5y'
}], ['path', {
  d: 'M14 6h0a6 6 0 016 6v3',
  key: 'oqwhop'
}]]);
export default HardHat;